import React from "react";

const PayperviewFeatured = () => {
  return (
    <div>
      <div className="flex justify-between max-sm:block max-md:block max-lg:block">
        {/* <div className="mb-5 mt-2 h-[30px] w-[200px] animate-pulse bg-[#1a1919]"></div> */}
      </div>
      <div className="h-[60vh] w-full animate-pulse rounded-2xl bg-[#1a1919] max-sm:h-[300px] max-xl:h-[380px] max-2xl:h-[460px] 2xl:h-[560px]"></div>
    </div>
  );
};

export default PayperviewFeatured;
